// initial state
const state = {
    all: [],
    tentativeCourses: []
  }
  
  // getters
  const getters = {
  }
  
  // actions
  const actions = {
    
  }
  
  // mutations
  const mutations = {
    setAll (state, all) {
      state.all = all
    },
    setTentative (state, tentative) {
      state.tentativeCourses = tentative
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }